// start instrumentation early
import '../instrumentation'

import React from 'react'
import './main.css'
import Configs from 'infrastructure/config/environment'
import firebase from 'firebase/compat/app'
import '@fontsource/roboto'

import * as Sentry from '@sentry/react'
import { createRoot } from 'react-dom/client'
// eslint-disable-next-line no-restricted-imports
import { createBrowserRouter, RouterProvider } from 'react-router'
import { routerRoutes } from 'app/routing/routes'
import { RootErrorFallback } from 'shared/ui/ErrorFallback'

import * as pdfjsLib from 'pdfjs-dist'
pdfjsLib.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjsLib.version}/build/pdf.worker.min.mjs`

firebase.initializeApp(Configs().firebaseConfig)

const container = document.getElementById('root')
if (container) {
  const root = createRoot(container)
  root.render(
    <Sentry.ErrorBoundary fallback={RootErrorFallback}>
      <RouterProvider router={createBrowserRouter(routerRoutes)} />
    </Sentry.ErrorBoundary>,
  )
}
